import LoveStory from "../../../entities/LoveStory/ui/LoveStory";

const LoveStoryPage = () => {    
    return ( 
        <main>
            <LoveStory/>
        </main>
    );
}
export default LoveStoryPage;